import { Ship } from "lucide-react";

const LANES = [
  "SHANGHAI → LONG BEACH",
  "HAMBURG → NEW YORK",
  "ROTTERDAM → SAVANNAH",
  "NINGBO → LOS ANGELES",
  "BUSAN → HOUSTON",
  "ANTWERP → CHARLESTON",
];

const Lane = ({ text }) => (
  <span className="flex shrink-0 items-center gap-10 pr-10 font-display text-lg font-bold tracking-[0.15em] text-[#00F0FF]/50 sm:text-xl">
    {text}
    <Ship className="h-5 w-5 text-[#0066FF]/60" />
  </span>
);

export default function Marquee() {
  return (
    <div className="relative overflow-hidden border-y border-[#0066FF]/15 bg-[#0B172A] py-6">
      <div className="marquee-track">
        <div className="flex">
          {LANES.map((lane) => (
            <Lane key={lane} text={lane} />
          ))}
        </div>
        <div aria-hidden="true" className="flex">
          {LANES.map((lane) => (
            <Lane key={`${lane}-echo`} text={lane} />
          ))}
        </div>
      </div>
    </div>
  );
}
